<app-header [selectedMenu]="MENU_PAGE.DONATION"></app-header>

<div class="container">

  <section class="sponsor">

    <div class="inner wrap">
      <div class="sponsor-list">
        <div class="list-wrap">
          <ul>
            <li>
              <div class="sponsor-box active">
                <div class="info-box">
                  <div class="subject-txt">응원 하기</div>
                  <div class="sub-txt">응원 하기 상세 문구 우리의 한국어를<br/>
                    널리 알려주세요!</div>
                </div>



                <div class="switch-box">
                  <div class="sponsor-img-box">
                    <div class="img-box type-hand"></div>
                  </div>


                  <div class="pay-box">
                    <div class="pay-btn-box">
                      <a href="#none" class="pay-btn type-kakao">

                        <i class="ic ic-kakao"></i>
                        <div class="txt">카카오페이</div>
                      </a>
                    </div>

                    <div class="pay-btn-box">
                      <a href="#none" class="pay-btn type-paypal">
                        <i class="ic ic-paypal"></i>
                        <div class="txt">PayPal</div>
                      </a>
                    </div>

                  </div>

                </div>



                <div class="sponsor-btn-box">
                  <a href="#none" class="sponsor-btn" onclick="">후원하기</a>
                </div>
              </div>
            </li>

            <li>
              <div class="sponsor-box">
                <div class="info-box">
                  <div class="subject-txt">정기회원</div>
                  <div class="sub-txt">정기회원 상세 문구<br/>
                    두줄로 노출시킵니다.</div>
                </div>


                <div class="switch-box">
                  <div class="sponsor-img-box">
                    <div class="img-box type-hand"></div>
                  </div>
                </div>


                <div class="sponsor-btn-box">
                  <a href="#none" class="sponsor-btn">후원하기</a>
                </div>
              </div>
            </li>



            <li>
              <div class="sponsor-box">
                <div class="info-box">
                  <div class="subject-txt">유료회원</div>
                  <div class="sub-txt">유료회원 상세 문구<br/>
                    두줄로 노출시킵니다.</div>
                </div>


                <div class="switch-box">
                  <div class="sponsor-img-box">
                    <div class="img-box type-hand"></div>
                  </div>

                </div>


                <div class="sponsor-btn-box">
                  <a href="#none" class="sponsor-btn">후원하기</a>
                </div>
              </div>
            </li>


            <li>
              <div class="sponsor-box">
                <div class="info-box">
                  <div class="subject-txt">마음 보태기</div>
                  <div class="sub-txt">마음보태기 상세 문구<br/>
                    두줄로 노출시킵니다.</div>
                </div>



                <div class="switch-box">
                  <div class="sponsor-img-box">
                    <div class="img-box type-basket"></div>
                  </div>


                  <div class="pay-box">
                    <div class="pay-btn-box">
                      <a href="#none" class="pay-btn type-kakao">
                        <div class="txt">카카오페이</div>
                      </a>
                    </div>

                    <div class="pay-btn-box">
                      <a href="#none" class="pay-btn type-paypal">
                        <div class="txt">PayPal</div>
                      </a>
                    </div>

                    <div class="pay-btn-box">
                      <div class="account-number">신한 110-29-19248</div>
                    </div>
                  </div>


                </div>


                <div class="sponsor-btn-box">
                  <a href="#none" class="sponsor-btn" onclick="sponsorToggle(this)">후원하기</a>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>


  </section>


  <!-- app-footer></app-footer -->
  <app-common-popups></app-common-popups>


</div>
<app-back-btn></app-back-btn>
